export interface GetShelfTypeTempChangeCollectionRequest {
  collectionId: number
  collectionNo: string
}

export function GetShelfTypeTempChangeCollectionRequestToJSON(
  value: GetShelfTypeTempChangeCollectionRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
